import React from 'react';
import CaseGenerator from "../../../CaseGenerator/CaseGenerator";
import {CaseForms} from "../../../../helpers/enums";

import './SegnalaUnGuastoCase.css';

const SegnalaUnGuastoCase = () => (
  <div className="SegnalaUnGuastoCase" data-testid="SegnalaUnGuastoCase">
    <CaseGenerator type={CaseForms.SegnalaUnGuasto}/>
  </div>
);


export default SegnalaUnGuastoCase;
